import { render, staticRenderFns } from "./article-problem-with-power.vue?vue&type=template&id=65820f87&scoped=true&"
import script from "./article-problem-with-power.vue?vue&type=script&lang=js&"
export * from "./article-problem-with-power.vue?vue&type=script&lang=js&"
import style0 from "./article-problem-with-power.vue?vue&type=style&index=0&id=65820f87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65820f87",
  null
  
)

export default component.exports